/**
 * AssetRadar SPA entry point.
 *
 * The stylesheet is imported exactly once, here: `styles/global.css` carries the
 * design tokens every component class depends on, so it must be in the bundle
 * before any component renders (Vite hoists CSS imports into a single file).
 *
 * StrictMode is on deliberately. It double-invokes effects in development, which
 * is what surfaced the need for the `requestSeq` guard in `lib/auth.tsx` — a
 * second `GET /api/auth/me` must not be able to overwrite a newer result.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  // index.html always ships <div id="root">; a missing node means the HTML shell
  // was replaced (or the backend served the "Frontend nicht gebaut" page), and a
  // hard error is far easier to diagnose than a silently blank screen.
  throw new Error('Mount-Punkt #root nicht gefunden — index.html ist nicht die AssetRadar-Shell.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
